import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';

import { useOrganization } from '../model';

import OrganizationFormContainer from './OrganizationFormContainer';

const DetailsDialog = () => {
  const { detailsDialogOpen, setDetailsDialogOpen } = useOrganization();

  const closeDialog = () => setDetailsDialogOpen(false);

  return (
    <Dialog open={detailsDialogOpen} onOpenChange={setDetailsDialogOpen}>
      <DialogContent className="sm:max-w-3xl gap-0">
        <DialogHeader className="mb-6 gap-1.5">
          <DialogTitle className="text-base font-bold">Edit organization details</DialogTitle>
          <DialogDescription>
            Enter your organization&apos;s registered name and address. These details will appear in your escrow
            agreements by default.
          </DialogDescription>
        </DialogHeader>
        <OrganizationFormContainer
          onCancel={closeDialog}
          successCallback={closeDialog}
          classes={{
            form: 'mb-4',
          }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default DetailsDialog;
